// Redirect page to start one page one if infinite scroll in use.
(() => {
  const currentUrl = new URL(window.location.href);
  const searchParams = new URLSearchParams(currentUrl.search);

  if (searchParams.has('page') && parseInt(searchParams.get('page')) >= 2) {
    searchParams.delete('page');
    const newUrl = `${currentUrl.origin}${currentUrl.pathname}?${searchParams.toString()}`;
    window.location.href = newUrl;
  }
})();

// Infinite scroll for collection product grid and search results grid
// Can be triggered either by observer or button click
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.nextUrl = this.dataset.nextUrl || null;
    this.isFetching = false;
    this.observer = null;

    // Attiva il bottone manuale se presente
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.fetchNextPage();
      });
    }

    // Attiva lo scroll automatico se impostato
    if (this.dataset.triggerType === 'infinite' && this.nextUrl) {
      this.initObserver();
    }
  }

  initObserver() {
    if (!this.nextUrl) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.fetchNextPage();
          }
        });
      },
      { threshold: 0.5 }
    );

    this.observer.observe(this);
  }

  async fetchNextPage() {
    if (this.isFetching || !this.nextUrl) return;

    this.isFetching = true;
    if (this.button) this.button.classList.add('loading');
    const overlay = this.querySelector('.loading-overlay');
    if (overlay) overlay.classList.remove('hidden');

    try {
      const response = await fetch(this.nextUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseText = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(responseText, 'text/html');

      const documentProductGrid = document.getElementById('product-grid-ajax');
      const documentPagination = document.getElementById('pagination-ajax');

      const fetchProductGrid = html.getElementById('product-grid-ajax');
      const fetchPagination = html.getElementById('pagination-ajax');

      if (!fetchProductGrid || !documentProductGrid) {
        this.disable();
        return;
      }

      // Rimuovi eventuali banner
      const banners = fetchProductGrid.querySelectorAll('.card--banner');
      banners.forEach((b) => b.parentNode && b.parentNode.removeChild(b));

      // 1) Se la pagina caricata contiene una griglia "semplice" (solo prodotti),
      //    la appendo così com'è.
      const simpleGridWrapper = fetchProductGrid.querySelector('.collection-simple-grid');

      if (simpleGridWrapper) {
        documentProductGrid.appendChild(simpleGridWrapper.cloneNode(true));
      } else {
        // 2) Altrimenti fallback standard: appendiamo solo le card prodotto
        const incomingProducts = fetchProductGrid.querySelectorAll(
          '.grid__item, .card-wrapper, .card--product'
        );

        incomingProducts.forEach((item) => {
          documentProductGrid.appendChild(item.cloneNode(true));
        });

        const incomingLifestyleImages =
          fetchProductGrid.querySelectorAll('.lifestyle-desktop');

        incomingLifestyleImages.forEach((img) => {
          documentProductGrid.appendChild(img.cloneNode(true));
        });
      }

      if (documentPagination && fetchPagination) {
        documentPagination.innerHTML = fetchPagination.innerHTML;
      }

      // Trova eventuale link alla prossima pagina
      let nextLink = fetchPagination
        ? fetchPagination.querySelector('a[rel="next"]')
        : null;
      if (!nextLink && fetchPagination) {
        nextLink = fetchPagination.querySelector(
          'a.pagination__next, a[href*="page="]'
        );
      }

      if (nextLink && nextLink.href) {
        this.nextUrl = nextLink.href;
        this.dataset.nextUrl = this.nextUrl;
      } else {
        this.disable(); // Nessuna pagina successiva
      }

      // Salva il contenuto in sessione per back button
      const container = document.getElementById('collection-ajax');
      if (container) {
        sessionStorage.setItem('pageContent', container.innerHTML);
        sessionStorage.setItem('pageContentURL', window.location.href);
      }
    } catch (err) {
      console.error('Errore nel caricamento successivo:', err);
    } finally {
      this.isFetching = false;
      if (this.button) this.button.classList.remove('loading');
      const overlayFinal = this.querySelector('.loading-overlay');
      if (overlayFinal) overlayFinal.classList.add('hidden');
    }
  }

  disable() {
    this.nextUrl = null;
    this.dataset.nextUrl = '';
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.button) this.button.style.display = 'none';
  }
}
customElements.define('infinite-scroll', InfiniteScroll);

// Load content from local storage logic
(() => {
  // Back button detection
  if (performance.navigation.type !== 2) {
    return;
  }

  const contentURL = sessionStorage.getItem('pageContentURL');
  if (window.location.href !== contentURL) return;

  const content = sessionStorage.getItem('pageContent');
  if (content) {
    const container = document.getElementById('collection-ajax');
    if (container) container.innerHTML = content;
  }
})();
